import PersonContextProvider from './state/landingPages/person/PersonContextProvider';
import ChildrenContextProvider from './state/landingPages/children/ChildrenContextProvider';
import PersonParentChildContextProvider from './state/landingPages/personParentChild/PersonParentChildContextProvider';
import CommunicationsHubContextProvider from './state/communicationsHub/CommunicationsHubContextProvider';

import VendorManagementContextProvider from './state/vendorManagement/VendorManagementContextProvider';
import UserGroupContextProvider from './state/userGroup/UserGroupContextProvider';
import AccountManagementUserGroupContextProvider from './state/accountManagement/accountManagementUserGroup/AccountManagementUserGroupContextProvider';
import PersonCertificationContextProvider from './state/landingPages/personCertification/PersonCertificationContextProvider';

import SystemMessageContextProvider from '@usas/ui-web/state/systemMessages/SystemMessageContextProvider';
import ManageUserAccountsContextProvider from '@usas/ui-web/state/manageUserAccounts/ManageUserAccountsContextProvider';
import ManageUserAccountsFilterContextProvider from '@usas/ui-web/state/manageUserAccounts/ManageUserAccountsFilterContextProvider';
import RenewalOptionContextProvider from '@usas/ui-web/state/renewalOption/RenewalOptionContextProvider';
import PersonAcknowledgementAddAFamilyMemberContextProvider from '@usas/ui-web/state/personAcknowledgementAddAFamilyMember/PersonAcknowledgementAddAFamilyMemberContextProvider';
import BasePersonContextProvider from '@usas/ui-web/state/personBase/BasePersonContextProvider';
import BasePersonFiltersContextProvider from '@usas/ui-web/state/personBase/BasePersonFiltersContextProvider';
import PersonAcknowledgementInfoContextProvider from '@usas/ui-web/state/personAcknowledgementInfo/PersonAcknowledgementInfoContextProvider';
import PersonAcknowledgementInfoPageViewContextProvider from '@usas/ui-web/state/personAcknowledgementInfo/PersonAcknowledgementInfoPageViewContextProvider';
import PersonGeneralContextProvider from '@usas/ui-web/state/personGeneral/PersonGeneralContextProvider';
import PaymentsByCheckContextProvider from '@usas/ui-web/state/paymentsByCheck/PaymentsByCheckContextProvider';
import PersonParentChildFamilyContactContextProvider from '@usas/ui-web/state/personParentChildFamilyContact/PersonParentChildFamilyContactContextProvider';
import ExternalAuthContextProvider from '@usas/ui-web/state/externalAuth/ExternalAuthContextProvider';

const AppStateContextProviders = ({ children }) => {

  return (
    <ExternalAuthContextProvider>
      <PersonAcknowledgementAddAFamilyMemberContextProvider>
        <BasePersonContextProvider>
          <BasePersonFiltersContextProvider>
            <PersonParentChildFamilyContactContextProvider>
              <PersonGeneralContextProvider>
                <PersonAcknowledgementInfoContextProvider>
                  <PersonAcknowledgementInfoPageViewContextProvider>
                    <RenewalOptionContextProvider>
                      <SystemMessageContextProvider>
                        <PersonCertificationContextProvider>
                          <PersonContextProvider>
                            <ChildrenContextProvider>
                              <PersonParentChildContextProvider>
                                <CommunicationsHubContextProvider>
                                  <AccountManagementUserGroupContextProvider>
                                    <UserGroupContextProvider>
                                      <VendorManagementContextProvider>
                                        <ManageUserAccountsContextProvider>
                                          <ManageUserAccountsFilterContextProvider>
                                            <PaymentsByCheckContextProvider>
                                              {children}
                                            </PaymentsByCheckContextProvider>
                                          </ManageUserAccountsFilterContextProvider>
                                        </ManageUserAccountsContextProvider>
                                      </VendorManagementContextProvider>
                                    </UserGroupContextProvider>
                                  </AccountManagementUserGroupContextProvider>
                                </CommunicationsHubContextProvider>
                              </PersonParentChildContextProvider>
                            </ChildrenContextProvider>
                          </PersonContextProvider>
                        </PersonCertificationContextProvider>
                      </SystemMessageContextProvider>
                    </RenewalOptionContextProvider>
                  </PersonAcknowledgementInfoPageViewContextProvider>
                </PersonAcknowledgementInfoContextProvider>
              </PersonGeneralContextProvider>
            </PersonParentChildFamilyContactContextProvider>
          </BasePersonFiltersContextProvider>
        </BasePersonContextProvider>
      </PersonAcknowledgementAddAFamilyMemberContextProvider >
    </ExternalAuthContextProvider>
  );
};

export default AppStateContextProviders;